import axios from 'axios'
import qs from 'qs'
import Config from '@/config'

function getTokenEndpoint() {
  return `${Config.SSO_URL}/realms/${Config.REALM_PB}/protocol/openid-connect/token`
}

function getTokenRequestHeaders() {
  const credentials = window.btoa(`${Config.CLIENT_ID}:${Config.CLIENT_SECRET}`)
  return {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Basic ${credentials}`,
  }
}

export function getSsoErrorMessage(error) {
  const data = error?.response?.data
  if (data?.error_description) {
    return data.error_description
  }
  if (data?.error) {
    return data.error
  }
  return error?.message || 'Falha ao autenticar com o SSO.'
}

export function getRedirectUri() {
  return window.location.origin + window.location.pathname
}

export function buildAuthorizeUrl(redirectUri = getRedirectUri()) {
  const params = new URLSearchParams({
    client_id: Config.CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid',
  })

  return `${Config.SSO_URL}/realms/${
    Config.REALM_PB
  }/protocol/openid-connect/auth?${params.toString()}`
}

export function getAuthorizationCode() {
  return new URL(window.location.href).searchParams.get('code')
}

export function clearAuthorizationCodeFromUrl() {
  const url = new URL(window.location.href)
  url.searchParams.delete('code')
  url.searchParams.delete('session_state')
  url.searchParams.delete('state')
  url.searchParams.delete('iss')
  window.history.replaceState(
    window.history.state,
    '',
    url.pathname + url.search,
  )
}

export async function exchangeAuthorizationCode(
  code,
  redirectUri = getRedirectUri(),
) {
  const { data } = await axios.post(
    getTokenEndpoint(),
    qs.stringify({
      grant_type: 'authorization_code',
      code,
      client_id: Config.CLIENT_ID,
      redirect_uri: redirectUri,
    }),
    {
      headers: getTokenRequestHeaders(),
    },
  )

  return data
}

export function applyKeycloakSession(keycloak, tokenResponse) {
  if (!keycloak || !tokenResponse?.access_token) {
    return
  }

  keycloak.token = tokenResponse.access_token
  keycloak.refreshToken = tokenResponse.refresh_token
  keycloak.idToken = tokenResponse.id_token
  keycloak.authenticated = true

  try {
    const base64Url = tokenResponse.access_token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    keycloak.tokenParsed = JSON.parse(jsonPayload)
  } catch (error) {
    keycloak.tokenParsed = null
  }
}
